<template>
  <div>
    <el-row>
      <el-col :span="24">
        <el-button
          style="padding: 0; margin: 20px"
          type="text"
          icon="el-icon-back"
          @click="$router.go(-1)"
        >
          返回
        </el-button>
      </el-col>
    </el-row>

    <el-form
      :model="info"
      ref="ruleForm"
      label-width="100px"
      class="demo-ruleForm"
    >

      <el-form-item label="讲师">
        <el-select
          class="search-el"
          size="mini"
          v-model="info.teacher_id"
          placeholder="请选择"
          clearable
          filterable
        >
          <el-option
            v-for="item in teacherList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="标题">
        <el-input
          v-model="info.title"
          maxlength="30"
          show-word-limit
          style="width:33%"
        ></el-input>
      </el-form-item>
      <el-form-item label="分类" prop="video_type">
          <el-select v-model="info.video_type" placeholder="请选择分类" style="width:33%">
              <el-option
                v-for="item in meetStoryCategory"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
          </el-select>
      </el-form-item>
      <el-form-item label="封面">
        <el-upload
          class="avatar-uploader"
          :action="ossAction"
          :show-file-list="false"
          :http-request="uploadOSSRequest"
          :before-upload="beforeImageUpload"
        >
          <img v-if="info.img_url" :src="info.img_url" class="avatar" />
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          <div slot="tip" class="el-upload__tip">
            只能上传jpg/png文件，且不超过500kb，封面大小160x213 ，封面比例为3：4
          </div>
        </el-upload>
      </el-form-item>

      <el-form-item label="视频">
        <el-upload
          class="avatar-uploader"
          action="ossAction"
          :http-request="videoUploadOSSRequest"
          :show-file-list="false"
          :before-upload="beforeVideoUpload"
        >
          <video v-if="info.media_url" :src="info.media_url" class="avatar" />
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          <div slot="tip" class="el-upload__tip">
            只能上传mp4、m4v文件，且不超过40M
          </div>
        </el-upload>
      </el-form-item>

      <el-form-item label="虚拟点赞数">
        <el-input v-model="info.virtual_likes" style="width:33%"></el-input>
      </el-form-item>

      <el-form-item label="发布时间">
        <el-date-picker
          v-model="info.released_at"
          type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
          placeholder="选择发布时间"
        >
        </el-date-picker>
      </el-form-item>

      <el-form-item>
        <el-button
          size="small"
          type="primary"
          @click="createUpdate()"
          :loading="updateLoading"
          >确 定</el-button
        >
      </el-form-item>
    </el-form>

    <div class="hides" v-if="isshow">
      <i style="margin-top: 20px; font-size: 40px" class="el-icon-loading"> </i
      ><br />
      正在上传
    </div>
  </div>
</template>

<script>
import {
  beforeImageUpload,
  uploadOSSRequest,
  beforeVideoUpload,
  getAliyunOssToken,

  getCategoryList,
  getTeacherList,
} from "@/api/common";

import {
  createUpdate,
  getDetail,  
} from "@/api/video";

import { getAllMeetStoryCategory} from "@/api/story";

export default {
  data: function () {
    return {
      isshow: false,
      ossAction: "",
      ossData: {},
      loading: false,
      aliyunOssToken: "",
      updateLoading: false,
      categoryList: [],
      teacherList: [],
      info: {
        id: 0,
        title: "",
        img_url: "",
        media_url: "",
        virtual_likes: 0,
        teacher_id: "",
        released_at: "",
        type: 6,
        video_type: null,
      },
      meetStoryCategory: [],
      categoryType:{
        type:2,
      },
    };
  },
  created: function () {
    this.getAllMeetStoryCategory()
    getCategoryList({ type_code: "video" }).then((response) => {
      this.categoryList = response.data;
    });
    getTeacherList().then((response) => {
      this.teacherList = response.data;
    });
    this.info.id = this.$route.query.id;
    if (this.info.id > 0) {
      this.getInfo();
    }
  },
  mounted() {},
  methods: {
    beforeImageUpload(file) {
      beforeImageUpload(file);
    },
    uploadOSSRequest(file) {
      getAliyunOssToken({ dir: "" }).then((res) => {
        uploadOSSRequest(file.file, res.data).then((fileUrl) => {
          this.info.img_url = fileUrl;
        });
      });
    },
    beforeVideoUpload(file) {
      beforeVideoUpload(file);
      this.isshow = true;
    },
    videoUploadOSSRequest(file) {
      getAliyunOssToken({ dir: "video/short_video/" }).then((res) => {
        uploadOSSRequest(file.file, res.data).then((fileUrl) => {
          this.info.media_url = fileUrl;
          this.isshow = false;
        });
      });
    },

    getInfo() {
      this.loading = true;
      getDetail({
        id: this.info.id,
      }).then((response) => {
        this.info = response.data;
        this.loading = false;
      });
    },
    createUpdate() {
      this.updateLoading = true;
      createUpdate(this.info)
        .then((response) => {
          this.updateLoading = false;
          if (response.code == 1) {
            this.$message.success(response.message);
            this.$router.push({
              path: "/videoIndex/agentList",
            });
          }
        })
        .catch((err) => {
          this.updateLoading = false;
        });
    },

    ref() {
      window.history.go(-1);
    },
    getAllMeetStoryCategory() {
      // this.loading = true;
      getAllMeetStoryCategory(this.categoryType).then((response) => {
        this.meetStoryCategory = response.data;
        // this.loading = false;
      });
    },
  },
};
</script>
<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
.hides {
  background: #fff;
  width: 100px;
  height: 100px;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  text-align: center;
}
</style>